import React, { useState } from "react";
import { Box, Typography } from "@mui/material";

import { getToken } from "../../../../api/Account";
import { addAbonoPrestamoAsync } from "../../../../api/Employees";
import { useAviso } from "../../../../components/base";
import { formatearMonto } from "../../../../helpers/formato";
import {
  CampoMonto,
  DialogoFormulario,
  esMontoEscribible,
  useEnvio,
  useEscritura,
} from "../comunes";

const AddAbono = ({ saldo, id, setShowModal, reload, setReload }) => {
  const [monto, setMonto] = useState("");
  const [intentado, setIntentado] = useState(false);

  const token = getToken();
  const aviso = useAviso();
  const escribir = useEscritura();
  const { guardando, enviar } = useEnvio();

  // Es la única regla de la pantalla: un abono tiene que ser mayor que cero. Que no pase del
  // saldo lo decide el servidor, y su mensaje se muestra tal cual.
  const montoValido = Number(monto) > 0;

  const saveChanges = () =>
    enviar(async () => {
      setIntentado(true);
      if (!montoValido) return;

      const data = {
        prestamoId: id,
        monto,
      };

      const ok = await escribir(
        () => addAbonoPrestamoAsync(token, data),
        "No se pudo agregar el abono"
      );
      if (!ok) return;
      aviso.exito("Abono agregado");
      setReload(!reload);
      setShowModal(false);
    });

  const funtionSetMonto = (value) => {
    if (esMontoEscribible(value)) setMonto(value);
  };

  // Solo es un aviso: no impide enviar.
  const superaSaldo = Number(monto) > Number(saldo);
  const ayuda = superaSaldo
    ? `Es mayor que el saldo pendiente (${formatearMonto(saldo)}).`
    : "Máximo: el saldo pendiente.";

  return (
    <DialogoFormulario
      titulo={`Agregar abono al préstamo #${id}`}
      onCerrar={() => setShowModal(false)}
      hayCambios={monto !== ""}
      guardando={guardando}
      onEnviar={saveChanges}
      textoEnviar="Agregar abono"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between",
          gap: 2,
          p: 2,
          mt: 1,
          mb: 2,
          borderRadius: 2,
          bgcolor: "soft.primary",
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 700 }}>
          Saldo actual
        </Typography>
        <Typography variant="monto" component="span" sx={{ color: "primary.main" }}>
          {formatearMonto(saldo)}
        </Typography>
      </Box>
      <CampoMonto
        autoFocus
        required
        label="Monto del abono"
        value={monto}
        onChange={funtionSetMonto}
        error={intentado && !montoValido ? "Ingrese un monto mayor que cero" : ""}
        ayuda={ayuda}
        disabled={guardando}
      />
    </DialogoFormulario>
  );
};

export default AddAbono;
